<template>
    <rkm-area
        title="Prescrição interna"
        type="fieldset"
    >
        <template slot="trailing">
            <rkm-button
                @click="internalVisible = !internalVisible"
                color="primary"
                small
            >
                <rkm-icon :icon="internalVisible ? 'angle-double-up' : 'angle-double-down'" />
            </rkm-button>
        </template>

        <rkm-collapse :visible="internalVisible">
            <List :data="data" />
        </rkm-collapse>
    </rkm-area>
</template>

<script>
// Components.
import List from './List'

export default {
    components: { List },
    created() {
        this.internalVisible = this.visible
    },
    data: () => ({
        internalVisible: false,
    }),
    props: {
        data: { type: Object, required: true },
        visible: { type: Boolean, default: true },
    },
}
</script>